import React from "react";

const GradientAnimation = ({ id, rotation, color, reverse }) => {
  return (
    <defs>
      <linearGradient id={id} gradientTransform={`rotate(${rotation})`}>
        {reverse ? (
          <>
            <stop offset="0%" stopColor={color.none}>
              <animate
                attributeName="stop-color"
                values={`${color.none};${color.none} ;${color.inactive}; ${color.none};`}
                dur="4s"
                repeatCount="indefinite"
              ></animate>
            </stop>

            <stop offset="100%" stopColor={color.none}>
              <animate
                attributeName="stop-color"
                values={`${color.none};${color.inactive} ;${color.none};${color.none};`}
                dur="4s"
                repeatCount="indefinite"
              ></animate>
            </stop>
          </>
        ) : (
          <>
            <stop offset="0%" stopColor={color.none}>
              <animate
                attributeName="stop-color"
                values={`${color.none};${color.inactive} ;${color.none};${color.none};`}
                dur="4s"
                repeatCount="indefinite"
              ></animate>
            </stop>

            <stop offset="100%" stopColor={color.none}>
              <animate
                attributeName="stop-color"
                values={`${color.none};${color.none} ;${color.inactive}; ${color.none};`}
                dur="4s"
                repeatCount="indefinite"
              ></animate>
            </stop>
          </>
        )}
      </linearGradient>
    </defs>
  );
};

export default GradientAnimation;
